<!--
 * @Autor: 李建鹏
 * @Date: 2022-07-26 21:18:13
 * @LastEditTime: 2022-10-13 11:51:05
 * @Description: 机型价格图表组件
-->
<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="price_chart">
    <div class="title" v-html="headerText"></div>
    <div class="price_chart-wrapper">
      <div id="echart"></div>
    </div>
  </div>
</template>

<script>
  import { chartConfig, isMaxNumber } from './chart'
  export default {
    components: {},
    props: {
      // $ 成色价格数据
      chartData: {
        type: Object,
        default: () => null,
      },
      // $ 当前商品原价 分
      originalPrice: {
        type: [String, Number],
        default: () => 0,
      },
    },
    data() {
      return {
        priceChart: null,
        highlightTxt: '高于',
        levelTxt: '95新',
        leftImg:
          'image://https://pic6.zhuanstatic.com/zhuanzh/53a77626-ac9e-457d-9dfc-4dd46f5b45e7.png',
        rightImg:
          'image://https://pic4.zhuanstatic.com/zhuanzh/99113c27-0e9b-4a29-9117-e6036c8241e0.png',
        conditionPrice: 269000, // $ 当前成色价格
        priceMap: new Map([
          [0, 60],
          [1, 60],
          [2, 70],
          [3, 90],
          [4, 96],
          [5, 100],
          [6, 104],
          [7, 114],
          [8, 120],
        ]), // $ 本机价格宽度映射数据
      }
    },
    computed: {
      computedOriginalPrice() {
        if (isNaN(+this.chartData.originalPrice)) return 0
        return this.chartData.originalPrice / 100
      },
      headerText() {
        if (!this.chartData) return
        return (
          this.chartData.headerText &&
          this.chartData.headerText.replace(/\${(.+)}/g, (match, p1) => {
            return `<span class="highlight">${p1}</span>`
          })
        )
      },
    },
    watch: {
      chartData() {
        // this.getLoadEcharts()
      },
    },
    mounted() {
      setTimeout(() => {
        this.getLoadEcharts()
      }, 100)
    },
    methods: {
      async getLoadEcharts() {
        if (!this.chartData || !window.echarts) return
        this.priceChart = echarts.init(document.getElementById('echart'))
        const formatYData = [] // $ 处理原始数据
        const barData = [] // $ 柱状图数据
        this.chartData.yData &&
          this.chartData.yData.forEach((item) => {
            formatYData.push((item && (item * 100) / 10000) || 0)
            barData.push('-')
          })
        // $ 获取当前成色在数组中的索引
        const conditionIdx =
          this.chartData.xData && this.chartData.xData.indexOf(this.chartData.finenessName)
        barData[conditionIdx] = isMaxNumber({
          yData: formatYData,
          originalPrice: this.computedOriginalPrice,
        })
        this.conditionPrice = formatYData[conditionIdx]
        const option = {
          ...chartConfig({
            xData: this.chartData.xData,
            yData: formatYData,
            originalPrice: this.chartData.originalPrice / 100,
            isDeleteLast: true,
            conditionIdx,
            isNeedMin: true,
          }),
          series: this.serisFormatter({ formatYData, barData, conditionIdx }),
        }
        this.priceChart.setOption(option, true)
      },
      serisFormatter({ formatYData, barData, conditionIdx }) {
        const [...circleData] = barData
        circleData[conditionIdx] = this.chartData.originalPrice / 100
        return [
          {
            name: '---',
            type: 'line',
            // smooth: true,
            // symbol: 'circle',
            clip: false,
            // showAllSymbol: true,
            symbolSize: 7,
            label: {
              show: false,
              position: 'top',
            },
            itemStyle: {
              normal: {
                color: '#ff0000',
                width: 1,
                borderWidth: 1,
              },
            },
            lineStyle: {
              width: 1,
              borderWidth: 1,
            },
            data: formatYData,
            markArea: {
              data: [],
            },
            markLine: {
              lineStyle: {
                color: 'rgba(50, 163, 182, 0.16)',
                width: 2,
              },
              symbolSize: 0,
              //当前为
              data: [],
            },
            markPoint: {
              z: 999,
              zlevel: 99,
              data: [
                {
                  name: this.chartData.finenessName,
                  coord: [this.chartData.finenessName, formatYData[conditionIdx]],
                },
              ],
              // symbol: 'none',
              symbolSize: 0, // 可以根据数值大小设置宽度
              symbolOffset: [0, this.computedOriginalPrice > this.conditionPrice ? 20 : -20], // 设置markpoint图标的位置
              label: {
                normal: {
                  padding: [5, 0, 10, 0],
                  // align: 'center',
                  // offset: [5, 0],
                  // backgroundColor: '#fff',
                  formatter: ({ name, data }) => {
                    return [`{a| ${name}均价\n}`, `{b| ￥}`, `{c|${data.coord[1]}}`].join('')
                  },
                  rich: {
                    a: {
                      fontSize: 10,
                      color: '#999',
                      lineHeight: 14,
                    },
                    b: {
                      color: '#FF7272',
                      fontSize: 10,
                      padding: [0, 0, 0, 5],
                    },
                    c: {
                      color: '#FF7272',
                      fontSize: 10,
                      // fontWeight: 700,
                      // align: 'center',
                      padding: [0, 0, 0, -1],
                    },
                  },
                },
                emphasis: {
                  show: true,
                },
              },
            },
          },
          {
            name: '---',
            type: 'bar',
            barWidth: 60,
            itemStyle: {
              normal: {
                // opacity: 0.4,
                color: 'rgba(255, 255, 255, .85)',
                shadowColor: 'rgba(0, 0, 0, .08)',
                shadowBlur: 10,
                backgroundColor: '#fff',
                barBorderRadius: [10, 10, 10, 10],
              },
            },
            data: barData,
          },
          {
            name: '--',
            // type: 'line',
            type: 'effectScatter',
            rippleEffect: {
              number: 2,
              period: 1,
              scale: 3,
              brushType: 'fill',
            },
            smooth: true,
            symbol: 'circle',
            showAllSymbol: true,
            symbolSize: 5,
            label: {
              show: false,
              position: 'bottom',
            },
            itemStyle: {
              normal: {
                color: '#ff0000',
                borderWidth: 10,
                shadowColor: 'rgba(255, 51, 51, 0.93)',
                shadowBlur: 40,
                borderColor: 'rgba(255,236,236,0.15)',
              },
            },
            markPoint: {
              data: [
                {
                  type: 'max',
                },
              ],
              symbol: () => this.priceImgPosition(conditionIdx),
              // symbolSize: [116, 24], // 可以根据数值大小设置宽度
              symbolSize: (value) => [this.priceMap.get(value.toString().length) || 130, 20],
              symbolOffset: [this.pricePosition(conditionIdx), 0], // 设置markpoint图标的位置
              // symbolOffset: [160, 0],
              label: {
                normal: {
                  fontSize: 14,
                  color: '#fff',
                  align: 'center',
                  offset: [this.pricePosition(conditionIdx) == 60 ? 0 : -5, 0], // $ 处理文字居中问题
                  formatter: ({ value }) => {
                    return [`{a| 本机价格}`, `{b| ￥}`, `{c|${value}}`].join('')
                  },
                  rich: {
                    a: {
                      fontSize: 10,
                      align: 'center',
                      fontFamily: 'PingFangSC-Regular, PingFang SC',
                    },
                    b: {
                      fontSize: 10,
                      fontWeight: 700,
                      padding: [2, 0, 0, -3],
                      fontFamily: 'PingFangSC-Medium, PingFang SC',
                    },
                    c: {
                      color: '#fff',
                      fontWeight: 700,
                      padding: [0, 0, 0, 0],
                      margin: 0,
                      // fontFamily: 'Akrobat',
                    },
                  },
                },
                emphasis: {
                  show: true,
                },
              },
            },
            data: circleData,
          },
          {
            clip: false,
            lineStyle: {
              type: 'dashed',
              width: 0.5,
            },
            itemStyle: {
              normal: {
                color: 'rgba(255, 51, 51, 1)',
              },
            },
            symbol: 'none',
            data: [
              [this.chartData.finenessName, this.computedOriginalPrice],
              [this.chartData.finenessName, formatYData[conditionIdx]],
            ],
            type: 'line',
          },
        ]
      },
      // $ 本机价格展示位置 左 or 右
      pricePosition(index) {
        const splitNumber = this.chartData.xData.length / 2
        // index === 0 微瑕在左侧  本机价格 < 成色价格
        // this.computedOriginalPrice < this.conditionPrice
        return index === 0 || splitNumber > index ? 60 : -60
      },
      priceImgPosition(index) {
        const splitNumber = this.chartData.xData.length / 2
        // this.computedOriginalPrice < this.conditionPrice ||
        return index === 0 || splitNumber > index ? this.leftImg : this.rightImg
      },
    },
    beforeDestory() {
      if (!this.priceChart) return //页面销毁钩子销毁chart释放资源
      this.priceChart.dispose()
      this.priceChart = null
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  @font-face {
    font-family: 'Akrobat';
    src: url('//s1.zhuanstatic.com/common/u/Akrobat-Black-subset-number.woff2') format('woff2'),
      url('//s1.zhuanstatic.com/common/u/Akrobat-Black-subset-number.ttf') format('truetype');
  }
  .price_chart {
    &-title {
      // font-size: 32px;
      // font-family: PingFangSC-Medium, PingFang SC;
      // font-weight: 500;
      // color: #000000;
      // line-height: 42px;
    }
    &-wrapper {
      width: 100%;
      height: 410px;
      background-color: #fff;
      border-radius: 40px;
      margin-top: -50px;
    }
  }

  #echart {
    width: 100%;
    height: 100%;
  }
</style>
